__turbopack_context__.v({
  "scrollableRow": "nY5YLW_scrollableRow",
});
